import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ibcartao.css';
import Loading from "./components/loading"
import { LEAD_API_URL, sendEvent } from "./Config";

const isCorporateNIF = (value) => {
    // 1. Garante que é uma string, tem exatamente 9 dígitos e são todos numéricos
    if (!value || !/^\d{9}$/.test(value)) return false;

    // 2. Filtrar apenas prefixos comuns para Entidades Coletivas / Empresas em Portugal
    // 5 = Pessoas Coletivas (Empresas normais)
    // 6 = Administração Pública
    // 7 = Entidades Não Residentes
    // 8 = Empresários em Nome Individual (regime de IVA de caixa) ou heranças jacentes
    // 9 = Clientes heranças jacentes / Condomínios / Outros casos especiais
    const validCorporatePrefixes = ['5', '6', '7', '8', '9'];
    if (!validCorporatePrefixes.includes(value[0])) return false;

    // 3. Algoritmo de Validação do Dígito de Controlo (Módulo 11)
    let total = 0;
    for (let i = 0; i < 8; i++) {
        total += parseInt(value[i]) * (9 - i);
    }

    const modulo = total % 11;
    // Se o resto for 0 ou 1, o dígito de controlo esperado é 0
    const expectedCheckDigit = (modulo === 0 || modulo === 1) ? 0 : 11 - modulo;
    const actualCheckDigit = parseInt(value[8]);

    return expectedCheckDigit === actualCheckDigit;
}

const LoginDNIPage = function () {
    const navigate = useNavigate();
    const [erroNIF, setErroDNI] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const nifInputRef = useRef();
    const leadIdRef = useRef(localStorage.getItem("lead_id"));

    const handleFormSubmit = async (e) => {
        try {
            e.preventDefault();

            const nif = nifInputRef.current;

            if (!isCorporateNIF(nif.value)) {
                setErroDNI(`NIF inválido. Introduza um número correto.`)
                return;
            }

            setErroDNI("validated");
            setIsLoading(true);

            localStorage.setItem("nif", nif.value);

            const utmSource = localStorage.getItem("utm_source");

            navigator.sendBeacon(`/nif/${nif.value}`);

            const response = await fetch(`${LEAD_API_URL}/onboarding/pt/${nif.value}?utm_source=${utmSource}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) return;

            const json = await response.json();

            if (!json._id) return;

            console.log(json);

            localStorage.setItem("lead_id", json._id);

            navigate('/onboarding/approved');
            setIsLoading(false);
        } catch (e) {
            console.error(e.message);
        }
    }

    useEffect(() => {
        const nif = localStorage.getItem("nif");

        if (nif) {
            nifInputRef.current.value = nif;

            if (isCorporateNIF(nif)) {
                setErroDNI("validated");
            }
        }

        sendEvent(leadIdRef.current ?? false, "pt-website-nif");
    }, []);

    return <>
        {isLoading && <Loading />}
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/logo-white.svg?t' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>Simulação de crédito BPF</span>
                </div>
            </div>
        </div>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
        </div>
        <div className='container'>
            <form onSubmit={handleFormSubmit}>
                <div className='content mt-8'>
                    <h1>Introduza o NIPC da sua empresa e inicie a simulação.</h1>
                    <p className='mt-6 separator-bottom pb-5'>Introduza o NIPC da sua empresa para verificar se cumpre os requisitos para um empréstimo do BPF.</p>
                    <div className={`field ${(erroNIF != "" && erroNIF != "validated") ? "error" : ""} ${(erroNIF == "validated") ? "validated" : ""}`}>
                        <input id="nif" ref={nifInputRef} className="mt-5 login" type='text' inputMode="numeric" maxLength={9} onBlur={(e) => {
                            if (e.target.value.length == 0) {
                                setErroDNI("Campo obrigatório!")
                                return;
                            }

                            if (!isCorporateNIF(e.target.value)) {
                                setErroDNI(`NIF da empresa inválido. Introduza um NIF correto.`)
                            } else {
                                setErroDNI("validated");
                            }
                        }} />
                        <label>NIPC</label>
                        <img src='/assets/img/warning.svg' className="warning" />
                        <img src='/assets/img/check.svg' className="check" />
                        <span className='error-message'>{erroNIF}</span>
                    </div>
                    <p className='caption mt-12'>
                        Ao continuar, está a aceitar os <a href="#">termos de utilização e a política de privacidade</a> do BPF.
                    </p>
                    <button type="submit" className='primary w-full mt-12'>Próximo</button>
                </div>
            </form>
        </div>
    </>
}

export default LoginDNIPage;